import React, { useRef, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const rootStyle = getComputedStyle(document.documentElement);
const color = rootStyle.getPropertyValue("--hoverColorBold").trim();
const lightColor = rootStyle.getPropertyValue("--graphColor1").trim();
const lightestColor = rootStyle.getPropertyValue("--graphColor2").trim();

const RevenueLineChart = ({data,dataLabel,label}) => {
    const chartRef = useRef(null);

    // Base chart data configuration
    const chartData = {
        labels: label,
        datasets: [
            {
                label: dataLabel,
                data: data ?? [0,0,0,0,0,0,0,0,0,0,0,0],
                borderColor: color,
                borderWidth: 2,
                fill: true,
                tension: 0.4,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
        },
        scales: {
            x: {
                stacked: true,
            },
             y: {
                beginAtZero: true, // Optional, starts the y-axis at 0
                ticks: {
                    stepSize: 1, // Ensures only whole numbers are displayed
                    precision: 0 // Prevents decimal values from being shown
                }
            }
        },
        onResize: (chart, size) => {
            // Update gradient when chart resizes
            if (chartRef.current) {
                updateGradient(chartRef.current);
            }
        },
    };

    // Function to update gradient
    const updateGradient = (chartInstance) => {
        const ctx = chartInstance.ctx;
        const chartArea = chartInstance.chartArea;


        if (!chartArea) return; // This case happens on initial chart load

        const gradient = ctx.createLinearGradient(
            0, chartArea.bottom,
            0, chartArea.top,
            0, chartArea.left,
        );
        gradient.addColorStop(0, lightestColor);
        gradient.addColorStop(1, lightColor);

        chartInstance.data.datasets.forEach((dataset) => {
            if (dataset.fill) {
                dataset.backgroundColor = gradient;
            }
        });
        chartInstance.update();
    };

    // Effect to handle gradient updates
    useEffect(() => {
        if (chartRef.current) {
            updateGradient(chartRef.current);
        }
    }, []);
    return (
        <div style={{width:'100%', height:'100%', position:'relative'}}>
            <Line
                ref={chartRef}
                data={chartData}
                options={options}
                
            />
        </div>
    );
};

export default RevenueLineChart;